import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface InvRommsProps {
  onBack: () => void;
}

export default function InvRomms({ onBack }: InvRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Inventory" />;
}



